import React from 'react';
import { Col, Row } from 'reactstrap';
import { Field } from 'react-final-form';
import { defaultMessages } from '@I18n/default';
import ReduxFormInput from '@Utils/ReduxFormInput';

export interface TranslationComponentProps {
  name: string;
  disabled: boolean;
}

const TranslationComponent: React.FC<TranslationComponentProps> = ({
  name,
  disabled,
}) => {
  return (
    <Row>
      <Col xs={12} md={6}>
        <Field
          name={`${name}.name`}
          type="string"
          disabled={disabled}
          component={ReduxFormInput}
          label={defaultMessages.publicationArmyBookFormLocNameLabel}
          placeHolder={
            defaultMessages.publicationArmyBookFormLocNamePlaceholder
          }
        />
      </Col>
      <Col xs={12} md={6}>
        <Field
          name={`${name}.value`}
          type="string"
          disabled={disabled}
          component={ReduxFormInput}
          label={defaultMessages.publicationArmyBookFormLocValueLabel}
          placeHolder={
            defaultMessages.publicationArmyBookFormLocValuePlaceholder
          }
        />
      </Col>
    </Row>
  );
};

export default TranslationComponent;
